module.exports = __webpack_public_path__ + "img/s1.02b3c10e.png";